/* angular 14 import { stringify } from '@angular/compiler/src/util';*/
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProductService } from 'src/app/core/services/product.service';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit, OnDestroy {

  //#region ProductComponent constructor & Ng Events
  constructor(private productService: ProductService, private route: ActivatedRoute, private userService : UserService) { }
  ngOnDestroy(): void {
    this.paramsSubscription.unsubscribe();
  }
  ngOnInit(): void {
    this.paramsSubscription = this.route.params.subscribe(params => {
      console.log('The id of this route is: ', params.id);
      this.products.productCategoryId= params.id;
    });
    const userObject = this.userService.readUserObject;
    const body = {
      productCategoryId: this.products.productCategoryId,
      languageCode: localStorage.getItem('language'),
      customerNumber: userObject.customerNumber
    }
    this.productService.getProductsByCategoryId(body).subscribe((products) => {
      console.log(products);
      this.products.products = products;
    });
  }
  //#endregion
  //#region ProductComponent Business Logic 
  public paramsSubscription: Subscription;
  public products = {
    products: this.productService.products,
    productCategoryId:0
  }
  //#endregion

}
